var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"checkout-container"},[_c('FormTitle',{staticClass:"checkout-container__title",attrs:{"title":_vm.$t('checkout.orderDetails')}}),_c('div',{staticClass:"mobile-item-container"},_vm._l((_vm.items),function(item){return _c('ConfirmOrderItem',{key:item.product_id,attrs:{"item":item}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }